/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, iterChildren, CanBeSignals, getProp, $GraphicsBox, copyRectangleData, RectangleLike} from '@gongxigames/framework/core/fragments/BuilderY';
import {cacheAsSprite} from '@gongxigames/framework/core/fragments/display/CacheAsSprite';
import {Store} from '@gongxigames/framework/core/fragments/store';
import {Rectangle, SCALE_MODES} from 'pixi.js';

export type IRectangle = {
    x: number;
    y: number;
    width: number;
    height: number;
};

export type AddProps = CanBeSignals<{
    name: string;
    region: RectangleLike;
    immediate?: boolean;
    debug?: boolean;
    doNotRemove?: boolean;
    resolution?: number;
    scaleMode?: SCALE_MODES;
}>;

export const $Add: FC<AddProps> = (props) => {
    const children = [...iterChildren(props.children)];

    if (children.length !== 1) {
        throw new Error('Cache: bitmap can be created from only one root container object');
    }

    const name = getProp(props.name);
    const immediate = getProp(props.immediate);
    const resolution = getProp(props.resolution);
    const scaleMode = getProp(props.scaleMode);

    const container = children[0];
    const region = new Rectangle();

    copyRectangleData(getProp(props.region), region);

    cacheAsSprite.add({
        name,
        immediate,
        resolution,
        scaleMode,
        region,
        provider: container
    });

    return Store.computed(() => {
        const debug = getProp(props.debug);
        const doNotRemove = getProp(props.doNotRemove);

        if (debug) {
            return <>
                {container}
                <$GraphicsBox
                    position={region}
                    boxWidth={region.width}
                    boxHeight={region.height}
                    boxColor={0xff00ff}
                    boxAlpha={0.6}
                />
            </>;
        }

        if (doNotRemove) {
            return container;
        }
    });
};